const COGNITO_ENDPOINT = 'https://cognito-idp.us-east-1.amazonaws.com/';

async function cognitoCall(target: string, body: object): Promise<any> {
  const res = await fetch(COGNITO_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-amz-json-1.1',
      'X-Amz-Target': `AmazonCognitoIdentityProviderService.${target}`,
    },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const code = data.__type || data.code || 'CognitoError';
    const msg = data.message || `Error ${res.status}`;
    throw Object.assign(new Error(msg), { code });
  }
  return data;
}

export const cognitoService = {
  async updateName(accessToken: string, name: string): Promise<void> {
    await cognitoCall('UpdateUserAttributes', {
      AccessToken: accessToken,
      UserAttributes: [{ Name: 'name', Value: name.trim() }],
    });
  },

  async changePassword(
    accessToken: string,
    previousPassword: string,
    proposedPassword: string,
  ): Promise<void> {
    await cognitoCall('ChangePassword', {
      AccessToken: accessToken,
      PreviousPassword: previousPassword,
      ProposedPassword: proposedPassword,
    });
  },
};
